module.exports = __webpack_public_path__ + "static/media/Close.4c47a932.svg";